import {
  DEFAULT_LANGUAGE,
  REGISTERED_LANGUAGES
} from '~/shared/constants/i18n';

export interface TolgeeConfig {
  apiKey: string | undefined;
  apiUrl: string | undefined;
  defaultLanguage: string;
  enableDevTools?: boolean;
  enableFormatIcu?: boolean;
  enableStaticData?: boolean;
}

/**
 * Gera staticData para o Tolgee usando JSONs gerados automaticamente
 * Os JSONs são gerados pelo script tolgee-update.sh (pull do Tolgee)
 * Isso mantém uma única fonte de verdade (Tolgee) com fallback automático
 *
 * IMPORTANTE: Fonte única de verdade é o Tolgee.
 * Os JSONs são apenas cache/fallback gerados automaticamente.
 * Desenvolvedores NUNCA devem editar os JSONs manualmente.
 */
const getStaticData = (): Record<
  string,
  () => Promise<Record<string, string>>
> => {
  const staticData: Record<string, () => Promise<Record<string, string>>> = {};

  for (const lang of REGISTERED_LANGUAGES) {
    const langKey = `${lang}:default`;

    // Usar fetch tanto no SSR quanto no Client
    // Next.js serve arquivos de /public como estáticos
    staticData[langKey] = async () => {
      try {
        const baseUrl =
          typeof window !== 'undefined'
            ? window.location.origin
            : process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000';
        const response = await fetch(`${baseUrl}/i18n/default/${lang}.json`);
        if (response.ok) {
          return (await response.json()) as Record<string, string>;
        }
      } catch {
        // Se falhar, retorna objeto vazio (fallback)
        // Tolgee tentará buscar da API
      }
      return {};
    };
  }

  return staticData;
};

export const getTolgeeConfig = (): TolgeeConfig => {
  return {
    apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
    defaultLanguage: DEFAULT_LANGUAGE,
    enableDevTools: process.env.NODE_ENV === 'development',
    enableFormatIcu: true,
    enableStaticData: true
  };
};

export { getStaticData };
